import React, { useState, useRef, useEffect } from 'react';
import '../../App.css';
import './OurCoffee.css';
import Footer from '../Footer';
import { useCart } from '../../contexts/CartContext';

const REGIONS = [
    'Brazil', 'Colombia', 'Colombia Rume Sudan (Rare)', 'Mexico', 'Nicaragua', 'Costa Rica',
    'Honduras', 'Ethiopia', 'Ethiopia Wush Wush (Rare)', 'Kenya', 'Uganda', 'Indonesia',
    'El Salvador', 'Burundi', 'Tanzania Peaberry', 'Peru', 'Guatemala', 'Yemen Mokha Matari (Rare)', 'Guatemala Gesha (Rare)',
    'Vietnam Project 96B Liberica (Rare)', 'Hawaii Kona Premium',
    'Ethiopia Gesha Village Oma Natural (Rare)', 'Ethiopia Gesha Village Surma Washed (Rare)'
];

const REGION_IMAGES = {
    'Peru': '/images/peru.png',
    'Colombia': '/images/colombia.png',
    'Brazil': '/images/brazil.png',
    'Mexico': '/images/mexico.png',
    'Guatemala': '/images/guatemala flag.png',
    'Nicaragua': '/images/nicaragua.png',
    'Costa Rica': '/images/costa rica.png',
    'Honduras': '/images/Honduras.png',
    'Ethiopia': '/images/ethiopia.png',
    'Kenya': '/images/kenya.png',
    'Uganda': '/images/uganda.png',
    'Indonesia': '/images/indonesia.png',
    'El Salvador': '/images/el salvador.png',
    'Burundi': '/images/burundi.png',
    'Tanzania Peaberry': '/images/tanzania.png',
    'Yemen Mokha Matari (Rare)': '/images/yemen.png',
    'Guatemala Gesha (Rare)': '/images/guatemala flag.png',
    'Colombia Rume Sudan (Rare)': '/images/colombia.png',
    'Ethiopia Wush Wush (Rare)': '/images/ethiopia.png',
};

const REGION_IMAGE_OFFSETS = {
    'Mexico': '0px',
    'Honduras': '0px',
    'Ethiopia': '0px',
    'Indonesia': '0px',
    'El Salvador': '0px',
    'Yemen Mokha Matari (Rare)': '0px',
};

const SIZE_PRICES = { '8oz': 20, '12oz': 24, '16oz': 27 };
const PREMIUM_PRICES = { '8oz': 25, '12oz': 29, '16oz': 32 };
const YEMEN_MOKHA_PRICES = { '8oz': 32 };
const GUATEMALA_GESHA_PRICES = { '8oz': 35 };
const VIETNAM_LIBERICA_PRICES = { '8oz': 45 };
const HAWAII_KONA_PRICES = { '8oz': 45 };
const RUME_SUDAN_PRICES = { '8oz': 50, '12oz': 70 };
const WUSH_WUSH_PRICES = { '8oz': 32, '12oz': 45, '16oz': 55 };
const TANZANIA_PEABERRY_PRICES = { '8oz': 30, '12oz': 40 };
const GESHA_VILLAGE_PRICES = { '4oz': 35 };
const SINGLE_SIZE_REGIONS = {
    'Yemen Mokha Matari (Rare)': YEMEN_MOKHA_PRICES,
    'Guatemala Gesha (Rare)': GUATEMALA_GESHA_PRICES,
    'Vietnam Project 96B Liberica (Rare)': VIETNAM_LIBERICA_PRICES,
    'Hawaii Kona Premium': HAWAII_KONA_PRICES,
    'Ethiopia Gesha Village Oma Natural (Rare)': GESHA_VILLAGE_PRICES,
    'Ethiopia Gesha Village Surma Washed (Rare)': GESHA_VILLAGE_PRICES,
};

// Per-region price overrides for single-origin bags (anything not listed uses SIZE_PRICES)
const REGION_PRICES = {
    'Yemen Mokha Matari (Rare)': YEMEN_MOKHA_PRICES,
    'Guatemala Gesha (Rare)': GUATEMALA_GESHA_PRICES,
    'Ethiopia Wush Wush (Rare)': WUSH_WUSH_PRICES,
    'Colombia Rume Sudan (Rare)': RUME_SUDAN_PRICES,
    'Tanzania Peaberry': TANZANIA_PEABERRY_PRICES,
    'Vietnam Project 96B Liberica (Rare)': VIETNAM_LIBERICA_PRICES,
    'Hawaii Kona Premium': HAWAII_KONA_PRICES,
    'Ethiopia Gesha Village Oma Natural (Rare)': GESHA_VILLAGE_PRICES,
    'Ethiopia Gesha Village Surma Washed (Rare)': GESHA_VILLAGE_PRICES,
};

export default function OurCoffee() {
    const [roastLevel, setRoastLevel] = useState('light');
    const [originType, setOriginType] = useState('single');
    const [selectedRegion, setSelectedRegion] = useState('Brazil');
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [regionDropdownOpen, setRegionDropdownOpen] = useState(false);
    const [size, setSize] = useState('8oz');
    const [quantity, setQuantity] = useState(1);
    const regionRef = useRef(null);
    const { addToCart, openDrawer } = useCart();

    useEffect(() => {
        document.title = 'Shop Specialty Coffee — Single Origin & Blends | OFFF THE ROAST';
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (regionRef.current && !regionRef.current.contains(e.target)) {
                setRegionDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleOriginChange = (e) => {
        setOriginType(e.target.value);
        setSelectedRegion('');
        setSelectedRegions([]);
    };

    const toggleRegion = (region) => {
        setSelectedRegions((prev) =>
            prev.includes(region) ? prev.filter((r) => r !== region) : [...prev, region]
        );
    };

    const regionDisplay = originType === 'blend'
        ? (selectedRegions.length > 0 ? selectedRegions.join(', ') : 'Select regions')
        : '';

    const regionImage = originType === 'single' ? REGION_IMAGES[selectedRegion] || null : null;
    const activePrices = (originType === 'single' && REGION_PRICES[selectedRegion]) || SIZE_PRICES;
    const price = size && activePrices[size] ? activePrices[size] : null;

    const handleAddToCart = () => {
        if (!roastLevel || !originType || !size) return;
        const region = originType === 'single' ? selectedRegion : selectedRegions.join(', ');
        addToCart({
            roastLevel,
            originType,
            region,
            size,
            quantity,
            unitPrice: price,
        });
        openDrawer();
    };

    return (
        <>
            <div className='oc-page'>
                <div className='oc-container'>
                    {/* Product Stage */}
                    <div className='oc-product-stage'>
                        {/* Title - flows with the card */}
                        <div className='oc-product-title'>
                            <h1>ORDER YOUR BAG NOW</h1>
                        </div>

                        <div className='oc-product-layout'>
                            {/* Left: Coffee Bag */}
                            <div className='oc-product-wrapper'>
                                <div className='oc-product-shadow'></div>
                                <div className='oc-coffee-bag'>
                                    <div className='oc-label-area'>
                                        <div className='oc-brand'>CRAFT ROAST</div>
                                        <div className='oc-tagline'>100% ARABICA</div>

                                        {/* Single Origin / Blend */}
                                        <div className='oc-select-group'>
                                            <label className='oc-select-label'>Single Origin / Blend:</label>
                                            <select
                                                className='oc-select'
                                                value={originType}
                                                onChange={handleOriginChange}
                                            >
                                                <option value='' disabled>Choose type</option>
                                                <option value='single'>Single Origin</option>
                                                <option value='blend'>Blend</option>
                                            </select>
                                        </div>

                                        {/* Select Region */}
                                        {originType && (
                                            <div className='oc-select-group'>
                                                <label className='oc-select-label'>Select Region:</label>
                                                {originType === 'single' ? (
                                                    <select
                                                        className='oc-select'
                                                        value={selectedRegion}
                                                        onChange={(e) => {
                                                            const region = e.target.value;
                                                            setSelectedRegion(region);
                                                            // If the current size isn't offered for this bean, pick its first size
                                                            const prices = REGION_PRICES[region] || SIZE_PRICES;
                                                            if (!prices[size]) setSize(Object.keys(prices)[0]);
                                                        }}
                                                    >
                                                        <option value='' disabled>Choose region</option>
                                                        {REGIONS.map((r) => (
                                                            <option key={r} value={r}>{r}</option>
                                                        ))}
                                                    </select>
                                                ) : (
                                                    <div className='oc-multi-select' ref={regionRef}>
                                                        <div
                                                            className='oc-multi-select-trigger'
                                                            onClick={() => setRegionDropdownOpen(!regionDropdownOpen)}
                                                        >
                                                            <span className={selectedRegions.length === 0 ? 'oc-placeholder' : ''}>
                                                                {regionDisplay}
                                                            </span>
                                                            <span className='oc-chevron'>{regionDropdownOpen ? '\u25B2' : '\u25BC'}</span>
                                                        </div>
                                                        {regionDropdownOpen && (
                                                            <div className='oc-multi-dropdown'>
                                                                {REGIONS.filter((r) => !SINGLE_SIZE_REGIONS[r]).map((r) => (
                                                                    <label key={r} className='oc-checkbox-item'>
                                                                        <input
                                                                            type='checkbox'
                                                                            checked={selectedRegions.includes(r)}
                                                                            onChange={() => toggleRegion(r)}
                                                                        />
                                                                        <span>{r}</span>
                                                                    </label>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Select Roast Level */}
                                        <div className='oc-select-group'>
                                            <label className='oc-select-label'>Select Roast Level:</label>
                                            <select
                                                className='oc-select'
                                                value={roastLevel}
                                                onChange={(e) => setRoastLevel(e.target.value)}
                                            >
                                                <option value='' disabled>Choose roast</option>
                                                <option value='light'>Light</option>
                                                <option value='medium'>Medium</option>
                                                <option value='medium-dark'>Medium / Dark</option>
                                                <option value='dark'>Dark</option>
                                            </select>
                                        </div>

                                        {/* Select Size */}
                                        <div className='oc-select-group'>
                                            <label className='oc-select-label'>Select Size:</label>
                                            <select
                                                className='oc-select'
                                                value={size}
                                                onChange={(e) => setSize(e.target.value)}
                                            >
                                                <option value='' disabled>Choose size</option>
                                                {Object.entries(activePrices).map(([s, p]) => (
                                                    <option key={s} value={s}>
                                                        {s === '16oz' ? '1 lb' : s === '8oz' ? '8 oz' : s === '12oz' ? '12 oz' : s === '4oz' ? '4 oz' : s} — ${p}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right: Purchase Section */}
                            <div className='oc-purchase-section'>
                                {regionImage && (
                                    <div
                                        className='oc-region-image-wrap'
                                        style={REGION_IMAGE_OFFSETS[selectedRegion] ? { marginLeft: REGION_IMAGE_OFFSETS[selectedRegion] } : {}}
                                    >
                                        <img src={regionImage} alt={selectedRegion} className='oc-region-image' />
                                    </div>
                                )}
                                <div className='oc-price-block'>
                                    <span className='oc-price-display'>
                                        {price !== null ? `$${price.toFixed(2)}` : '$\u2014'} <span className='oc-currency'>USD</span>
                                    </span>
                                </div>

                                <div className='oc-quantity-row'>
                                    <span className='oc-quantity-label'>QUANTITY</span>
                                    <div className='oc-quantity-controls'>
                                        <button
                                            className='oc-qty-btn'
                                            onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                                        >
                                            &minus;
                                        </button>
                                        <input
                                            className='oc-qty-input'
                                            type='number'
                                            min='1'
                                            value={quantity}
                                            onChange={(e) => {
                                                const val = parseInt(e.target.value, 10);
                                                if (val >= 1) setQuantity(val);
                                            }}
                                        />
                                        <button
                                            className='oc-qty-btn'
                                            onClick={() => setQuantity((q) => q + 1)}
                                        >
                                            +
                                        </button>
                                    </div>
                                </div>

                                <button
                                    className="oc-add-to-cart"
                                    onClick={handleAddToCart}
                                    disabled={!roastLevel || !originType || !size}
                                >
                                    ADD TO CART
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
